// Renders the real product app-icon when available, else a clean lettermark
// tile in the product accent. Square, app-icon styling.
export const ProductLogo = ({ product, className = "", rounded = "rounded-[24%]" }) => {
  if (product.logo) {
    return (
      <div
        className={`overflow-hidden ${rounded} border border-hairline bg-white ${className}`}
      >
        <img
          src={product.logo}
          alt={`${product.name} logo`}
          loading="lazy"
          className="h-full w-full object-cover"
        />
      </div>
    );
  }
  return (
    <div
      className={`flex items-center justify-center ${rounded} font-bold text-white ${className}`}
      style={{ backgroundColor: product.accent }}
      aria-hidden
    >
      {product.name.charAt(0)}
    </div>
  );
};
